import { render, staticRenderFns } from "./order-items-list.vue?vue&type=template&id=361b4c76&scoped=true&"
import script from "./order-items-list.vue?vue&type=script&lang=js&"
export * from "./order-items-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b4c76",
  null
  
)

export default component.exports